<template>
  <span class="curtainStateWidget">
    <template
      v-if="value.toLowerCase() === 'open' || value.toLowerCase() === 'off'"
    >
      <span :title="`${ curtainTypeName } ${ statusText }`">
        <v-icon :color="disabledColor" :size="iconSize"
          >{{ curtainStatusIcon }}</v-icon
        >
      </span>
    </template>
    <template v-else-if="value.toLowerCase() === 'closed'">
      <span :title="`${ curtainTypeName } ${ statusText }`">
        <v-icon :color="disabledColor" :size="iconSize"
          >{{ curtainStatusIcon }}</v-icon
        >
      </span>
    </template>
    <template v-else-if="value.toLowerCase() === 'opening'">
      <span :title="`${ curtainTypeName } Opening`">
        <v-icon :color="disabledColor" :size="iconSize"
          >arrow_upward</v-icon
        >
      </span>
    </template>
    <template v-else-if="value.toLowerCase() === 'closing'">
      <span :title="`${ curtainTypeName } Closing`">
        <v-icon :color="disabledColor" :size="iconSize"
          >arrow_downward</v-icon
        >
      </span>
    </template>
    <template v-else-if="value.toLowerCase() === 'updating'">
      <span :title="`${ curtainTypeName } status updating`">
        <img src="/img/Spinner-1s-30px.gif" />
      </span>
    </template>
  </span>
</template>

<script>
export default {
  name: "",
  props: ["value", "iconSize", "device", "disabled"],
  components: {},
  beforeMount() {},
  mounted() {},
  data() {
    return {};
  },

  computed: {
    disabledColor() {
      return this.disabled ? 'rgb(192, 192, 192)': null
    },
    curtainTypeName() {
      return this.device.curtainType === 'AIR RAIL' ? 'Air Rail' : 'Curtains'
    },
    statusText() {
      if (this.device.curtainType !== 'AIR RAIL' && (this.value.toLowerCase() === 'open' || this.value.toLowerCase() === 'off')) {
        return 'Open'
      }
      if (this.device.curtainType === 'AIR RAIL' && (this.value.toLowerCase() === 'open' || this.value.toLowerCase() === 'off')) {
        return 'Off'
      }
      if (this.device.curtainType !== 'AIR RAIL' && this.value.toLowerCase() === 'closed') {
        return 'Closed'
      }
      if (this.device.curtainType === 'AIR RAIL' && this.value.toLowerCase() === 'closed') {
        return 'On'
      }
    },
    curtainStatusIcon() {
      if(this.value.toLowerCase() === 'open' || this.value.toLowerCase() === 'off') {
        return 'maximize'
      } else if (this.value.toLowerCase() === 'closed') {
        return 'reorder'
      }
      return ''
    }
  },
  watch: {},
  methods: {}
};
</script>
<style lang="scss"></style>
